import { IconProps } from "../../utils/global-types/global-types";

const DeleteIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M15.218 4.358a76 76 0 0 0-3.318-.253v-.007l-.151-.891c-.103-.631-.254-1.577-1.858-1.577H8.095c-1.598 0-1.749.905-1.858 1.57l-.144.877a60 60 0 0 0-1.913.144l-1.399.137a.515.515 0 0 0-.466.563.51.51 0 0 0 .562.459l1.399-.137c3.592-.357 7.213-.22 10.846.144h.055a.52.52 0 0 0 .514-.466.525.525 0 0 0-.473-.563M13.957 6.353a.87.87 0 0 0-.624-.268H4.667a.855.855 0 0 0-.857.912l.425 7.034c.075 1.043.171 2.345 2.564 2.345H11.2c2.393 0 2.49-1.296 2.565-2.345l.425-7.027a.9.9 0 0 0-.233-.651m-3.82 6.588H7.856a.52.52 0 0 1-.515-.514c0-.281.234-.514.515-.514h2.283c.28 0 .514.233.514.514a.52.52 0 0 1-.514.514m.577-2.742H7.286a.52.52 0 0 1-.515-.514c0-.281.233-.514.515-.514h3.428c.28 0 .514.233.514.514a.52.52 0 0 1-.514.514"
      ></path>
    </svg>
  );
};

export default DeleteIcon;
